<template>
  <div>
    <menu-bar>
    </menu-bar>
    <div style="margin: 0 auto;width: 80%;margin-top: 24px">
      <div style="height: 32px;margin-bottom: 12px">
        <el-tag effect="plain">当前比例:{{ referenceDisCount }}</el-tag>
      </div>
      <el-card style="min-width: 500px;margin-right: 12px;" :body-style="{ padding:'0px' }">
        <div id="echartsContainer" style="min-height: 200px"></div>
      </el-card>
    </div>

  </div>
</template>

<script>
import * as echarts from 'echarts';
import {dailyDiscount} from "../../api/api";
import MenuBar from "../Menu/menuBar.vue";

export default {
  name: "DisCountHistory",
  components: {MenuBar},
  data(){
    return{
      referenceDisCount: 0,
      echarts: {},
      echartsOption: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            label: {
              show: true
            }
          }
        },
        calculable: true,
        legend: {
          data: ['日期'],
          itemGap: 5
        },
        grid: {
          height: '90%',
          left: '10%',
          right: '10%',
          bottom: '12%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: []
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: ''
          }
        ],
        dataZoom: [
          {
            show: true,
            bottom: '5%',
            start: 0,
            height: 15,
            end: 100
          },
          {
            type: 'inside',
            start: 0,
            end: 100
          },
          {
            show: true,
            yAxisIndex: 0,
            filterMode: 'empty',
            width: 15,
            height: '90%',
            showDataShadow: false,
            right: '5%',
            bottom: '5%',
            start: 65
          }
        ],
        series: [
          {
            name: '挂刀比例',
            smooth: true,
            type: 'line',
            data: [],
            markPoint: {
              data: []
            }
          },
        ]
      },
    }
  },
  mounted() {
    this.echarts = echarts.init(document.getElementById('echartsContainer'));
    this.echarts.showLoading();
    dailyDiscount().then(json => {
      this.$set(this.echartsOption.xAxis[0], 'data', json.data.data.dateList)
      this.$set(this.echartsOption.series[0], 'data', json.data.data.disCountList)
      this.$set(this.echartsOption.series[0].markPoint, 'data', json.data.data.markPoints)
      this.referenceDisCount = Math.floor(json.data.data.referenceDisCount * 1000) / 1000
      this.echarts.setOption(this.echartsOption);
    }).finally(_ => {
      this.echarts.hideLoading()
    })
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/ui/DisCountHistory/DisCountHistory.vue